import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostBinding, Input,
  OnDestroy, OnInit, Output, ViewEncapsulation
} from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { NgTemplateOutlet } from '@angular/common';
import { Subscription } from 'rxjs';

import {
  DataTableColumnTypeEnum, DeviceService, IconSizeEnum, ImageRatioEnum, SdBannerComponent, SdButtonComponent,
  SdIconComponent, SdLinkComponent, SdTagComponent, TypographyUtils, SdHtmlComponent
} from '@seb/web-design-system/core';

import { SdRatingComponent } from '@seb/web-design-system/reviews';

import type { IButtonCell, ITableCell } from './table-cell.interface';

@Component({
  selector: 'sd-table-cell, [sd-table-cell]',
  templateUrl: 'table-cell.component.html',
  styleUrls: ['./table-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    NgTemplateOutlet,
    SdIconComponent,
    SdBannerComponent,
    SdTagComponent,
    SdButtonComponent,
    SdRatingComponent,
    SdLinkComponent,
    SdHtmlComponent,
    TranslateModule
  ]
})
export class SdTableCellComponent implements OnInit, OnDestroy {
  @HostBinding('class.is-inline')
  @Input()
  isInline = false;

  @Input()
  set type(type: DataTableColumnTypeEnum) {
    if (type) {
      this._type = type;
    }
  }

  @Input()
  cellContent: ITableCell;

  @Output()
  cellClicked = new EventEmitter<IButtonCell>();

  @Output()
  linkClicked = new EventEmitter<string>();

  DataTableColumnTypeEnum = DataTableColumnTypeEnum;
  ImageRatioEnum = ImageRatioEnum;
  IconSize = IconSizeEnum;

  isMobile: boolean;
  isCellEmpty = false;
  isContentPictoEmpty = false;
  subscriptions = new Subscription();
  _type = DataTableColumnTypeEnum.media;

  constructor(
    private cdRef: ChangeDetectorRef,
    private deviceService: DeviceService
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.deviceService.isMobile.subscribe((x) => {
        this.isMobile = x;
        this.cdRef.markForCheck();
      })
    );

    this.isCellEmpty = TypographyUtils.isEmptyObject(this.cellContent);
    this.isContentPictoEmpty = this.cellContent?.value === undefined || this.cellContent?.value === null;

    if (this.cellContent?.type) {
      this._type = this.cellContent?.type;
    } else if (this.cellContent?.scale) {
      this._type = DataTableColumnTypeEnum.scale;
    } else if (
      (this.cellContent?.icon && !this.cellContent?.button?.isButton) ||
      this.cellContent?.media
    ) {
      this._type = DataTableColumnTypeEnum.media;
    } else if (this.cellContent?.tag) {
      this._type = DataTableColumnTypeEnum.tag;
    } else if (this.cellContent?.button) {
      this._type = DataTableColumnTypeEnum.button;
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onClick(event: IButtonCell): void {
    this.cellClicked.emit(event);
  }

  onLinkClicked(event: string): void {
    this.linkClicked.emit(event);
  }
}
